import { PrimaryButton } from "components/Button/style";
import {
  ButtonContainer,
  Container,
  ContainerHeader,
  FormContainer,
  Title,
} from "./style";
import { FaFilter } from "react-icons/fa";
import { Controller, useForm } from "react-hook-form";
import { Col, Form, Row } from "react-bootstrap";
import { useMaskInput } from "hooks/useMaskInput";
import { yupResolver } from "@hookform/resolvers/yup";
import { CustomInput } from "components/CustomInput";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import { IFiltrosListarLicenciamentos } from "../../interfaces/IFiltrosListarLicenciamentos";
import { filtrosListarLicenciamentos } from "../../validate/validator";
import { OptionsStatusEmisssao } from "../../constants/optionsStatusEmissao";

interface Props {
  handleSubmitFiltros: (
    idLote: number,
    dados?: IFiltrosListarLicenciamentos,
  ) => void;
  idLote: number;
}

const anoAtual = new Date().getFullYear();

const opcoesAno = [
  { label: String(anoAtual), value: anoAtual },
  { label: String(anoAtual - 1), value: anoAtual - 1 },
];

export function FiltrosDetalhesLicenciamento({
  handleSubmitFiltros,
  idLote,
}: Readonly<Props>) {
  const { handleSubmit, control, reset } = useForm({
    resolver: yupResolver(filtrosListarLicenciamentos),
  });
  const { mInputPlaca, mInputRenavam } = useMaskInput();

  return (
    <Container>
      <ContainerHeader>
        <Title>Filtros</Title>
      </ContainerHeader>
      <hr />
      <FormContainer>
        <Form
          noValidate
          onSubmit={handleSubmit((dados) => {
            handleSubmitFiltros(idLote, {
              ...dados,
              placa: dados.placa?.replace(/-/g, ""),
            });
          })}
        >
          <Row>
            <Col lg="2">
              <Form.Group>
                <Form.Label>Placa</Form.Label>
                <Controller
                  control={control}
                  name="placa"
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      style={{ height: "2.2rem", borderRadius: "0.5rem" }}
                      type="text"
                      placeholder="Digite a placa"
                      value={value!}
                      onChange={(e: any) => onChange(mInputPlaca(e))}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col lg="2">
              <Form.Group>
                <Form.Label>Renavam</Form.Label>
                <Controller
                  control={control}
                  name="renavam"
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      style={{ height: "2.2rem", borderRadius: "0.5rem" }}
                      type="text"
                      placeholder="Digite o Renavam"
                      value={value!}
                      onChange={(e: any) => onChange(mInputRenavam(e))}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col lg="2">
              <Form.Group>
                <Form.Label>Status emissão</Form.Label>
                <Controller
                  control={control}
                  name="statusEmissao"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={OptionsStatusEmisssao}
                      selectedValue={value}
                      onSelect={onChange}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col lg="2">
              <Form.Group>
                <Form.Label>Exercício</Form.Label>
                <Controller
                  control={control}
                  name="exercicio"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={opcoesAno}
                      selectedValue={value}
                      onSelect={onChange}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col lg="2">
              <ButtonContainer>
                <PrimaryButton
                  onClick={() => {
                    reset({
                      placa: "",
                      renavam: "",
                      statusEmissao: null,
                      exercicio: null,
                    });
                    handleSubmitFiltros(idLote);
                  }}
                  disabled={false}
                  outline={true}
                  variante="primary"
                  type="button"
                >
                  Limpar
                </PrimaryButton>
                <PrimaryButton type="submit" disabled={false}>
                  <FaFilter /> Filtrar
                </PrimaryButton>
              </ButtonContainer>
            </Col>
          </Row>
        </Form>
      </FormContainer>
    </Container>
  );
}
